// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import { Authenticator, Theme, ThemeProvider } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import Navbar from "./components/Navbar";
import "./styles/app.scss";
import { theme } from "./theme";
import { UserProvider } from "./utils/UserProvider";
import {
  componentsAuth,
  formFieldsAuth,
  servicesAuth,
} from "./utils/authentication";

Amplify.configure(awsExports);
const amplifyTheme: Theme = {
  name: "vetscribe-theme",
  tokens: {
    fonts: {
      default: {
        variable: {
          value: `"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"`,
        },
        static: {
          value: `"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"`,
        },
      },
    },
    colors: {
      font: {
        primary: "black",
        secondary: "black",
        tertiary: "white",
      },
      primary: {
        10: "#003554",
        20: "#003554",
        30: "#003554",
        40: "#003554",
        50: "#003554",
        60: "#003554",
        70: "#003554",
        80: "#003554",
        90: "#003554",
        100: "#003554",
      },
    },
  },
};

Sentry.init({
  dsn: "https://2a11f02194d23e4750b1e250f8a7a050@o4509172193230848.ingest.us.sentry.io/4509172194476032",
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

export default function App() {
  const [searchParams] = useSearchParams();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formFields, setFormFields] = useState<any>(formFieldsAuth);

  useEffect(() => {
    const referralCode = searchParams.get("referral");
    if (referralCode) {
      formFields.signUp.formFields["defaultValue"] = referralCode;
      setFormFields({ ...formFields });
    }
  }, []);

  return (
    <ThemeProvider theme={amplifyTheme}>
      <MantineProvider theme={theme}>
        <Notifications />
        <Authenticator.Provider>
          <Authenticator
            services={servicesAuth}
            formFields={formFields}
            components={componentsAuth}
            className="wrap-authentication"
          >
            <UserProvider>
              <Navbar />
            </UserProvider>
          </Authenticator>
        </Authenticator.Provider>
      </MantineProvider>
    </ThemeProvider>
  );
}
